"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _dist = require("@low6dev/react-utils/dist");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"])), function (p) {
  return p.hasBottomMargin && "4rem";
});

var StyledLink = _styledComponents.default.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n"])));

var StyledIframeLink = _styledComponents.default.a(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n  height: 100%;\n"])));

var StyledImage = _styledComponents.default.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: ", ";\n"])), function (p) {
  return p.hasBottomMargin && "4rem";
});

var StyledIframeWrapper = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 150px;\n\n  @media (min-width: ", ") {\n    height: 240px;\n  }\n\n  @media (min-width: ", ") {\n    height: 200px;\n  }\n"])), function (p) {
  return p.theme.screenWidthXs;
}, function (p) {
  return p.theme.screenWidthMd;
});

var StyledIframe = _styledComponents.default.iframe(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: scale(0.425) translate(-50%, -50%);\n  border: 0;\n  transform-origin: 0% 0%;\n  margin-top: -20px;\n  margin-bottom: -100px;\n\n  @media (min-width: ", ") {\n    transform: scale(0.75) translate(-50%, -50%);\n  }\n\n  @media (min-width: ", ") {\n    transform: scale(0.525) translate(-50%, -50%);\n  }\n"])), function (p) {
  return p.theme.screenWidthXs;
}, function (p) {
  return p.theme.screenWidthMd;
});

var StyledBlock = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background: transparent;\n  z-index: 1;\n"])));

var Wrapper = function Wrapper(_ref) {
  var hasBottomMargin = _ref.hasBottomMargin,
      imageUrl = _ref.imageUrl,
      ctaUrl = _ref.ctaUrl,
      iframeUrl = _ref.iframeUrl,
      appName = _ref.appName,
      index = _ref.index;

  var openLink = function openLink(url) {
    var position;

    switch (index) {
      case 0:
        position = "Top";
        break;

      case 2:
      case 3:
        position = "Middle";
        break;

      case 5:
      case 6:
        position = "Bottom";
        break;

      default:
        position = "";
        break;
    }

    window.xtremepush("tag", "AffiliateBanner.Click.".concat(position), JSON.stringify({
      AppName: appName
    }));
    window.open(url, '_blank').focus();
  };

  return iframeUrl ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledIframeWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBlock, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIframeLink, {
        href: ctaUrl,
        onClick: function onClick() {
          return openLink(ctaUrl);
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIframe, {
      width: "980",
      height: "270",
      srcDoc: "<script src=".concat(iframeUrl, "></script><style>body { margin: 0; } iframe { border: 0; }</style>")
    })]
  }) : ctaUrl || affiliateBannerUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    hasBottomMargin: hasBottomMargin,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, {
      onClick: function onClick() {
        return openLink(ctaUrl || affiliateBannerUrl);
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledImage, {
        src: (0, _dist.createImageCdnLink)(imageUrl || "vbet-banner.png")
      })
    })
  }) : imageUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledImage, {
    hasBottomMargin: hasBottomMargin,
    src: (0, _dist.createImageCdnLink)(imageUrl)
  }) : null;
};

var _default = Wrapper;
exports.default = _default;